import { motion } from 'framer-motion';

import { cn } from '~/utils';

type SelectCardProps = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  id: string | number;
  ignoreDisabledClick?: boolean;
  onClick?: (id?: any) => void;
  selected?: boolean;
};
const SelectCard = ({
  id,
  children,
  disabled = false,
  ignoreDisabledClick = false,
  selected = false,
  onClick,
  className,
}: SelectCardProps) => (
  <motion.li
    layout="position"
    whileHover={{ y: selected ? 0 : -2, transition: { duration: 0.2 } }}
    className={cn(
      'border-neutral-250 bg-neutral-0 hover:border-neutral-250 hover:shadow-drop flex w-full cursor-pointer flex-col items-start justify-center gap-3 rounded-2xl border p-6 transition-all',
      {
        'border-accent-blue-300 hover:border-accent-blue-300 border border-dashed bg-[#EFF0FC]':
          selected,
      },
      className,
    )}
    onClick={(e) => {
      const eventTarget = e.target as HTMLElement;
      if (
        !eventTarget.localName.includes('button') &&
        !eventTarget.localName.includes('a')
      ) {
        onClick && (!disabled || ignoreDisabledClick) && onClick(id);
      }
    }}
  >
    {children}
  </motion.li>
);

export default SelectCard;
